import React, { useState } from "react";
import { Tabs, Tab, Box, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Page from "./products/index";
import { useCart } from "../CartContext";
import AddIcon from "@mui/icons-material/Add";
import Swal from "sweetalert2";

const MultiTabPage = () => {
  const { cart, dispatch } = useCart();
  const [activeTab, setActiveTab] = useState(0);
  const [tabs, setTabs] = useState(() => {
    if (Object.keys(cart).length === 0) {
      const newId = 1;
      return [{ id: newId, label: `แท็บ ${newId}`, data: [] }]
    } else {
      if (cart && typeof cart === "object") {
        return Object.keys(cart).map((key) => ({
          id: Number(key),
          label: `แท็บ ${key}`,
          data: cart[key],
        }));
      }
    }
  });
  const handleAddTab = () => {
    const newId = Math.max(0, ...tabs.map((tab) => tab.id)) + 1;
    setTabs([...tabs, { id: newId, label: `แท็บ ${newId}`, data: [] }]);
    setActiveTab(tabs.length);
  };

  const handleRemoveTab = (index) => {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: "ยืนยันที่จะปิดแท็บนี้?",
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const newTabs = tabs.filter((_, i) => i !== index);
        let tabId = tabs[index].id;
        dispatch({ type: "CLEAR_CART", payload: { tabId } });
        setTabs(newTabs);
        setActiveTab((prev) => (prev > 0 ? prev - 1 : 0));
      }
    });
  };
  const handleUpdateTabData = (index, newData) => {
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs];
      updatedTabs[index].data = newData;
      return updatedTabs;
    });
  };

  const handleTransactionSaved = (index) => {
    // Keep the first tab as the ready-to-use buying tab. Completed extra tabs
    // should not remain open as empty tabs.
    if (index === 0) {
      setActiveTab(0);
      return;
    }

    setTabs((prevTabs) => prevTabs.filter((_, tabIndex) => tabIndex !== index));
    setActiveTab(index - 1);
  };
  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ marginLeft: "60px" }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={tab.id}
            label={
              <Box display="flex" alignItems="center">
                {tab.label}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveTab(index);
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            }
          />
        ))}
        <Button onClick={handleAddTab}>
          <AddIcon />
          เพิ่มแท็บ
        </Button>
      </Tabs>

      <Box sx={{ p: 2 }}>
        {tabs.map(
          (tab, index) =>
            activeTab === index && (
              <Page
                tabId={tab.id}
                tabData={tab.data}
                updateTabData={(newData) => handleUpdateTabData(index, newData)}
                onTransactionSaved={() => handleTransactionSaved(index)}
              />
            )
        )}
      </Box>
    </Box>
  );
};

export default MultiTabPage;
